<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible1"
    :before-close="handleClose"
    :append-to-body="true"
  >
    <table-form
      :dataSource="dataSource"
      ref="form"
      :tableData="data"
    ></table-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import TableForm from "common/components/form/tableForm";
import { step2, step5 } from "@/conf/Report-manager";
import { step2Agency } from "@/conf/Report-angency";
import { nation, selectDic, addUpdateMes } from "common/js/api";

export default {
  components: {
    TableForm,
  },

  props: ["dialogVisible1", "title", "data", "reportCode", "fundId", "codeId"],

  data() {
    return {
      dataSource: [],
      dialogFormVisible: false,
      formData: {},
      isManager: true,
    };
  },

  created() {
    // 设置配环境
    this.setEnvironment();
  },

  mounted() {
    this.setConf();
  },
  methods: {
    async getnation() {
      const result = await nation(0);
      this.dataSource[3].options = result.result.map((item) => ({
        label: item.district,
        value: item.district,
      }));
    },

    async getManagerSelect() {
      const query = "4,5,6";
      const result = await selectDic(query);
      const {
        FUND_PRODUCT_TYPE,
        INVEST_INDUSTRY,
        INVEST_PROID,
      } = result.result;

        this.converSelect(INVEST_INDUSTRY, 1);
      
    },

    converSelect(option, index) {
      var newArray = [];
      option.forEach((item) => {
        let data = {
          label: item,
          value: item,
        };
        newArray.push(data);
      });
      this.dataSource[index] && this.dataSource[index].options
        ? (this.dataSource[index].options = newArray)
        : "";
    },

    setEnvironment() {
      const path = this.$route.path;
      if (path == "/QuaReport/AgencyMan") {
        this.isManager = true;
      } else {
        this.isManager = false;
      }
    },

    async setConf() {
      if (this.isManager) {
        this.dataSource = step5;
        await this.getManagerSelect();
        await this.getnation();
      } else {
        this.dataSource = step2Agency;
      }
    },

    async submit() {
     
        const isValidate = this.$refs.form.submitForm();
        if (!isValidate) return false;
        let form = this.$refs.form.form;
   

        // code id
        form.reportCode = this.codeId;
        form.fundId = this.fundId;
      
        if (this.title.includes("编辑")) {
            form.id = this.data.id;
            form.reportCode = this.reportCode;
        }else {
            form.reportCode = this.codeId;
        }
        
        await addUpdateMes(this.title, form);
         const message = this.title.includes("添加") ? "添加" : "编辑";
        this.$message({
            message: `已发行产品${message}成功!`,
            type: "success"
        });
        this.$emit("reloads");
        this.handleClose();
      
    },

    handleClose() {
      this.formData = {};
      this.dialogFormVisible = false;
      this.$emit("closeDialog1");
    },
  },

  watch: {
    dialogVisible1: {
      handler(val) {
        this.dialogFormVisible = val
      },
      deep: true
    }
  },
};
</script>
